import React from 'react'
import { Link } from 'react-router-dom'

const More_Hosting = () => {
  return (
    <div>
         <section class="relative bg-black/30">
                              <div class="absolute inset-0 bg-gradient-to-r from-blue-500/5 via-transparent to-blue-500/5 blur-2xl"></div>
                              <div class="relative isolate px-6 py-10 sm:py-10">
                                    <div class="absolute inset-0 -z-10">
                                          <div class="absolute inset-0 bg-gradient-to-b from-[#030622] via-black to-black">
                                          </div>

                                          <div class="absolute inset-0">
                                                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[150px]">
                                                      <div
                                                            class="absolute inset-0 bg-gradient-to-r from-blue-900/20 to-blue-600/20 blur-[100px] animate-slow-pulse">
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="relative mx-auto max-w-7xl">
                                          <div class="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/shared-hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <img src="assets/images/shared-hosting.png" class="w-16" alt="" />
                                                                  <h3 class="text-lg font-bold text-white">Shared Hosting</h3>
                                                            </div>
                                                      </Link>
                                                </div>
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/vps-hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <img src="assets/images/VPS-hosting.png" class="w-16" alt="" />
                                                                  <h3 class="text-lg font-bold text-white">VPS Hosting</h3>
                                                            </div>
                                                      </Link>
                                                </div>
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/dedicated-hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <img src="assets/images/dedicated-hosting.png" class="w-16" alt="" />
                                                                  <h3 class="text-lg font-bold text-white">Dedicated Hosting</h3>
                                                            </div>
                                                      </Link>
                                                </div>
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/wordPress-hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <img src="assets/images/wordpress-hosting.png" class="w-16" alt="" />
                                                                  <h3 class="text-lg font-bold text-white">Wordpress Hosting</h3>
                                                            </div>
                                                      </Link>
                                                </div>

                                          </div>
                                    </div>
                              </div>
                        </section>
    </div>
  )
}

export default More_Hosting
